import * as yup from 'yup';

// Use this schema when an endpoint does not return a response body

/*
 * yup doesn't appear to have any way to map a schema to `undefined` so we have
 * to manually cast it here for proper TypsSript intellisense.
 */
export const EmptyResponseSchema = yup
  .mixed()
  .nonNullable()
  .test(val => val === undefined) as yup.MixedSchema<
  undefined,
  yup.AnyObject,
  undefined,
  ''
>;

export type EmptyResponse = yup.InferType<typeof EmptyResponseSchema>;
